<i18n>
{
  "en": {
    "welcome-to-livepaow": "Welcome to Livepaow",
    "welcome-description-text": "Full management tools for your live shop. Helping you manage your sales systematically. Develop and manage your business efficiently.",
    "read-document": "Read document"
  },
  "th": {
    "welcome-to-livepaow": "ยินดีต้อนรับสู่ Livepaow",
    "welcome-description-text": "เครื่องมือจัดการร้านค้าไลฟ์สดเต็มรูปแบบ ช่วยคุณบริหารยอดขายของคุณอย่างเป็นระบบ พัฒนาและจัดการธุรกิจได้อย่างมีประสิทธิภาพ",
    "read-document": "Read document"
  }
}
</i18n>

<template>
  <div class="background-linear-gradient-pink-orange white--text py-12">
    <v-container
      class="fill-height pt-12"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="8"
          lg="5"
          xl="3"
        >
          <div class="hidden-sm-and-down">
            <div class="display-1 font-weight-medium my-lg-2 pb-4">{{ $t('welcome-to-livepaow') }}</div>
            <div class="subtitle-1 font-weight-medium my-lg-2">{{ $t('welcome-description-text') }}</div>
            <div class="my-2 pt-8">
              <paow-create-shop-button />
            </div>
          </div>

          <div class="hidden-xs-only hidden-md-and-up">
            <div class="headline font-weight-medium my-lg-2 pb-4">{{ $t('welcome-to-livepaow') }}</div>
            <div class="subtitle-2 font-weight-medium my-lg-2">{{ $t('welcome-description-text') }}</div>
            <div class="my-2 pt-8">
              <paow-create-shop-button />
            </div>
          </div>

          <div class="hidden-sm-and-up text-center">
            <div class="title font-weight-medium my-lg-2 pb-4">{{ $t('welcome-to-livepaow') }}</div>
            <div class="body-1 font-weight-medium my-lg-2">{{ $t('welcome-description-text') }}</div>
            <div class="my-2 pt-8">
              <paow-create-shop-button />
            </div>
          </div>

        </v-col>
        <v-col
          cols="12"
          lg="2"
        >
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="fill-height background-linear-gradient-pink-orange py-10"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12">
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import PaowCreateShopButton from '../../components/PaowCreateShopButton'
export default {
  name: 'TheCShopContentFirst',
  components: { PaowCreateShopButton }
}
</script>

<style scoped>

</style>
